export default __webpack_public_path__ + "static/media/docx.7f86fe58.svg";